import { Link } from 'react-router-dom';

const Privacy = () => {
    return (
        <div className="min-h-screen bg-dark text-gray-100 p-8 font-sans">
            <div className="max-w-4xl mx-auto space-y-8">
                <div className="flex justify-between items-center mb-12">
                    <Link to="/" className="text-xl font-bold text-primary hover:text-primary/80 transition-colors">
                        &larr; Back to App
                    </Link>
                    <h1 className="text-4xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-primary to-pink-400">
                        Privacy Policy
                    </h1>
                </div>

                <div className="bg-slate/10 border border-slate/20 shadow-2xl rounded-[2.5rem] overflow-hidden">
                    <div className="p-10 prose prose-invert max-w-none">
                        <section className="space-y-4 mb-8">
                            <h2 className="text-2xl font-black uppercase tracking-tighter text-white">1. Introduction</h2>
                            <p className="text-gray-400">Welcome to DIYCarMech. We respect your privacy and are committed to protecting your personal data. This privacy policy informs you about how we handle your personal data when you visit our website.</p>
                        </section>

                        <section className="space-y-4 mb-8">
                            <h2 className="text-2xl font-black uppercase tracking-tighter text-white">2. Data We Collect</h2>
                            <p className="text-gray-400">We may collect, use, store and transfer different kinds of personal data about you:</p>
                            <ul className="list-disc list-inside text-gray-400 space-y-2 ml-4">
                                <li><strong>Identity Data:</strong> First name, last name, and profile picture (via Google Sign-In).</li>
                                <li><strong>Contact Data:</strong> Email address.</li>
                                <li><strong>Vehicle Data:</strong> VIN, make, model, year, and engine details you provide.</li>
                                <li><strong>Usage Data:</strong> Information about how you use our website, products, and services, including chat history for diagnostics.</li>
                            </ul>
                        </section>

                        <section className="space-y-4 mb-8">
                            <h2 className="text-2xl font-black uppercase tracking-tighter text-white">3. How We Use Your Data</h2>
                            <p className="text-gray-400">We use your data to provide accurate automotive diagnostics, improve our AI models (anonymized data only), and manage your account and subscription preferences.</p>
                        </section>

                        <section className="space-y-4 mb-8">
                            <h2 className="text-2xl font-black uppercase tracking-tighter text-white">4. Data Sharing</h2>
                            <p className="text-gray-400">We do not sell your personal data. We may share search queries with third-party search engines (like Google or SearXNG) to retrieve relevant repair information, but this is done without sharing your personal identity.</p>
                        </section>

                        <section className="space-y-4 mb-8">
                            <h2 className="text-2xl font-black uppercase tracking-tighter text-white">5. Affiliate Disclosure</h2>
                            <p className="text-gray-400">DIYCarMech is a participant in the Amazon Services LLC Associates Program and the eBay Partner Network. These affiliate advertising programs provide a means for us to earn fees by linking to Amazon.com, eBay.com, and affiliated sites. This comes at no extra cost to you.</p>
                        </section>

                        <section className="space-y-4 mb-8">
                            <h2 className="text-2xl font-black uppercase tracking-tighter text-white">6. Contact Us</h2>
                            <p className="text-gray-400">If you have any questions about this Privacy Policy, please contact our support team.</p>
                        </section>

                        <p className="text-sm text-gray-500 mt-12 pt-8 border-t border-white/5">Last Updated: January 2026</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Privacy;
